import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MEvaluationEvidence } from '../../models/evaluation-evidence.model';
import { SieniService } from '../../services/sieni.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Alert } from '../../models/alert.model';


@Component({
  selector: 'evidence-item',
  templateUrl: './evidence-item.component.html',
  styleUrls: ['./evidence-item.component.scss']
})
export class EvidenceItemComponent implements OnInit {

  constructor(private _globalService: SieniService, private translate: TranslateService) { }

  @Input() public evidence: MEvaluationEvidence;
  @Input() public evaluationId: number;
  @Input() public requirementId: number;
  @Output() public deleted = new EventEmitter<{id: number, reqId: number}>()
  public env: string = null;
  public isDeleting: boolean = false;

  ngOnInit() {
    this.env = environment.apiUrl
    this.translate.use(this._globalService.user.language.code)

  }

  public deleteEvidence(){
    if (!this.isDeleting) {
      this.isDeleting = true;
      const req = this.requirementId;
      this._globalService.updateRequiremtenEvaluationEvidence(this.evaluationId, this.requirementId, 
        [
          {id: this.evidence.id, name: null, base64: null}
        ]
      ).subscribe(res=>{
        Alert.buildSuccessAlert(this.translate.instant('evaluations.update.alert.evidenceDeleteSuccess', {name: this.evidence.description}))
        this.deleted.emit({id: this.evidence.id, reqId: req})
      }, err=>{
        Alert.buildErrorAlert(this.translate.instant('evaluations.update.alert.evidenceDeleteError', {name: this.evidence.description}))
        this.isDeleting = false;
      })
    }
  }

}
